import { Dispatch, SetStateAction } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import AddPromotionalBanner from "../../Modals/addPromotionalBanner";
import { isValidInput } from "../../utils/validations";
import usePermission from "../../hooks/usePermission";
import useTranslation from "../../hooks/traslation";
import { SUPPORTED_LANGUAGES } from "../../constants/languages";
import type { PromotionalBannerTexts } from "../../services/promotionalBanners";

type Props = {
  open: boolean;
  category: string;
  texts: PromotionalBannerTexts;
  status: boolean;
  isPrimary: boolean;
  selectedId: string;
  setCategory: Dispatch<SetStateAction<string>>;
  setTexts: Dispatch<SetStateAction<PromotionalBannerTexts>>;
  setStatus: Dispatch<SetStateAction<boolean>>;
  setIsPrimary: Dispatch<SetStateAction<boolean>>;
  setSelectedId: Dispatch<SetStateAction<string>>;
  handleSubmit: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setDebouncedSearchTerm: Dispatch<SetStateAction<string>>;
  setSearchTerm: Dispatch<SetStateAction<string>>;
  searchTerm: string;
  isFormLoading?: boolean;
};

const PromotionalBannersTopbar = ({
  open,
  setOpen,
  category,
  texts,
  status,
  isPrimary,
  setCategory,
  setTexts,
  setStatus,
  setIsPrimary,
  handleSubmit,
  selectedId,
  setSelectedId,
  setDebouncedSearchTerm,
  setSearchTerm,
  searchTerm,
  isFormLoading = false,
}: Props) => {
  const { isAdd } = usePermission({
    label: "Manage Promotional Banners",
    page_permission: "isView",
  });

  const handleCloseModal = () => {
    setOpen(false);
  };

  const translate = useTranslation();

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              placeholder={
                translate?.user?.SearchHere || "Search here..."
              }
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: React.ChangeEvent<HTMLInputElement>) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </Box>
        </div>
        {isAdd ? (
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => {
                setCategory("");
                setTexts(
                  SUPPORTED_LANGUAGES.reduce<PromotionalBannerTexts>((acc, { code }) => {
                    acc[code] = "";
                    return acc;
                  }, {})
                );
                setStatus(true);
                setIsPrimary(false);
                setSelectedId("");
                setOpen(true);
              }}
            >
              <AddIcon />{" "}
              {translate?.promotionalBanner?.addBanner || "Add Promotional Banner"}
            </Button>
          </div>
        ) : null}
      </div>
        {open &&
      <AddPromotionalBanner
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        category={category}
        texts={texts}
        status={status}
        isPrimary={isPrimary}
        setCategory={setCategory}
        setTexts={setTexts}
        setStatus={setStatus}
        setIsPrimary={setIsPrimary}
        handleSubmit={handleSubmit}
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        isFormLoading={isFormLoading}
      />
      }
    </>
  );
};

export default PromotionalBannersTopbar;
